import React from "react";
// import { Link } from "react-router-dom";
// import VideoModal from "../../shared/Modal";
import Modal from "../../shared/Modal";

const Project = props => {
    function displayHtml() {
        return { __html: props.project.short_description };
    }

    return (
        <div className="island">
            <h2>{props.childFirstName}'s World</h2>

            <div className="country-map">
                <img
                    className="img-responsive"
                    src={props.project.map_url}
                    alt=""
                />
            </div>

            <div className="program-info">
                <div dangerouslySetInnerHTML={displayHtml()} />
            </div>

            {/* <div>{props.childVideo}</div> */}
            {/* <VideoModal content={props.childVideo} type="video" el="link" rating_target={props.project.id} rating_type="community_video" /> */}
            <Modal 
                content={props.childVideo} 
                type="video" 
                el="community_video" 
                rating_target={props.project.id} 
                rating_type="community_video" 
                rating_meta={{
                    //child_id: props.child.child_id, 
                    //target: props.childVideo[2].key, 
                    target: props.project.id,
                    content: props.childVideo
                }}
            />
        </div>
    );
};

Project.defaultProps = {
    childFirstName: "Child",
    childVideo: "ChildVideo"
};

export default Project;
